<template>
  <input
    type="text"
    :value="value"
    :maxlength="maxlength"
    :v-on:blur="blur"
    @input="sanitizeAndEmit($event.target.value)"
    @blur="$emit('blur', $event.target.value)"
    @change="$emit('change', $event.target.value)"
  >
</template>

<script>
export default {
  name: 'InputNumerc',
  props: {
    value: {
      type: String,
      required: true,
      default: ''
    },
    maxlength: {
      type: String,
      required: true,
      default: ''
    },
    blur: {
      type: Function,
      required: false
    },
    change: {
      type: Function,
      required: false
    }
  },
  watch: {
    // 親からの値変更の時もサニタイズするためにwatch
    value(newValue) {
      this.sanitizeAndEmit(newValue);
    }
  },
  mounted() {
    this.sanitizeAndEmit(this.value);
  },
  methods: {
    sanitizeAndEmit(val) {
      // 半角数字のみ許可、全角数字を半角数字へ変換
      this.$emit(
        'input',
        val.replace(/[^0-9０-９]/g, '').replace(/[０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xFEE0))
      );
      // サニタイズされた値は直前の値と変わらないので再描画されない 強制的に再描画しないと、表示と実際の値がずれる
      this.$forceUpdate();
    }
  }
};
</script>
